import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';

export const TokenInterceptor: HttpInterceptorFn = (request, next) => {
  const credentialsService = inject(CredentialsService);
  const token = credentialsService.credentials?.token;

  request = request.clone({
    setHeaders: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  return next(request);
};
